export default __webpack_public_path__ + "static/media/notification.b5ea1705.mp3";